<template>
  <div>
    <b-card
      style="border-radius: 16px; border: 1px solid #dee3ea"
      class="main-card"
    >
      <div class="setting-btn" @click="onClickSetting" v-if="hasSettingBtn">
        <img src="img/svg/VectorNew.svg" />
      </div>
      <div class="text-center">
        <div class="tenantProfile_img">
          <img class="image" :src="imageUrl" />
        </div>
        <h3>
          <span> {{ name }}</span>
        </h3>
        <div>
          <span class="iconss"><i class="fa fa-phone"></i></span
          ><span class="text-dark">{{ phone }}</span>
        </div>
        <div class="mt-1">
          <span class="iconss"><i class="fa fa-envelope"></i></span
          ><span class="text-dark">{{ email }}</span>
        </div>
      </div>
      <div class="mt-3">
        <slot></slot>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "Sourav Samanta",
    },
    email: {
      type: String,
      default: "mail@test.com",
    },
    phone: {
      type: String,
      default: "9609327591",
    },
    hasSettingBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickSetting() {
      this.$emit("clickOnSetting");
    },
  },
};
</script>

<style>
.iconss {
  color: var(--primary);
  margin-right: 5px;
}
.main-card {
  position: relative;
}
.setting-btn {
  cursor: pointer;
  position: absolute;
  top: 1%;
  right: 3%;
}
.setting-btn img {
  width: 21px;
}
.tenantProfile_img {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  border: 2px solid #4645e7;
  margin: 0 auto;
}
.tenantProfile_img img {
  max-width: 145px;
  width: auto;
  max-height: 145px;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
  margin-bottom: 0px;
  object-fit: cover;
}
</style>
